import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PrivacyNoticeDto } from '@models/webapi/privacy-notice/privacy-notice.model';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpErrorHandlerService } from './http-error-handler.service';
import {
  PRIVACY_NOTICE_ACK_ENDPOINT,
  PRIVACY_NOTICE_ENDPOINT,
} from '@models/common.models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PrivacyNoticeService {
  readonly #http = inject(HttpClient);
  readonly #httpErrorHandler = inject(HttpErrorHandlerService);
  readonly #webApiUrl = environment.apiConfig.baseUrl;

  public getCurrent(): Observable<PrivacyNoticeDto | null> {
    return this.#http
      .get<PrivacyNoticeDto>(`${this.#webApiUrl}${PRIVACY_NOTICE_ENDPOINT}`)
      .pipe(
        map(response => PrivacyNoticeDto.from(response)),
        catchError((error: unknown) => {
          this.#httpErrorHandler.handleError(error);
          return of(null);
        })
      );
  }

  public acknowledgePrivacyNotice(version: number): Observable<void> {
    return this.#http
      .post<void>(`${this.#webApiUrl}${PRIVACY_NOTICE_ACK_ENDPOINT}`, {
        version,
      })
      .pipe(
        catchError((error: unknown) => {
          this.#httpErrorHandler.handleError(error);
          return of();
        })
      );
  }
}
